import * as r from "react";
import { useRef as pe, useMemo as qe, useCallback as se, useEffect as We } from "react";
import { u as U, r as $e, a as _e, b as Ge, c as X, d as Je, e as Ke, f as de, g as Qe, h as Ye, i as be, j as Xe, k as Ze, m as et, G as tt, n as nt, o as rt, p as ge, q as st, t as ot, v as xe, w as ve, x as Fe, y as at, l as V, z as it, A as ct, B as ye, C as ut, D as lt, E as dt, F as ft, H as pt, I as mt, J as ht, K as bt, M as Me, N as gt, O as vt, P as yt, Q as St, S as Ct, T as kt, U as Et, V as Tt, W as Ue, X as Mt, Y as wt, Z as Pt, _ as Rt, $ as Lt, a0 as At, a1 as Ot, a2 as It, a3 as Dt, a4 as Nt, a5 as _t, a6 as xt, a7 as he, a8 as G, a9 as Ft, aa as Ut, ab as zt, ac as Ht, ad as ze } from "./contexts-BtSGUJjc.mjs";
import { m as J } from "./room-BC_ml4G1.mjs";
import { ConnectionState as I, LocalTrackPublication as Vt, facingModeFromLocalTrack as jt, Room as He, Track as P, createAudioAnalyser as Se, ParticipantKind as ue, Mutex as Bt, RoomEvent as H, ParticipantEvent as ie, ExternalE2EEKeyProvider as qt, decodeTokenPayload as Wt, TokenSourceConfigurable as $t, RpcError as te, serializers as we, isSerializer as Gt } from "livekit-client";
const Jt = (e) => {
  const n = r.useRef(e);
  return r.useEffect(() => {
    n.current = e;
  }), n;
};
function Kt(e, n) {
  const t = Yt(), o = Jt(n);
  return r.useLayoutEffect(() => {
    let s = !1;
    const a = e.current;
    if (!a) return;
    function i(u, l) {
      s || o.current(u, l);
    }
    return t?.subscribe(a, i), () => {
      s = !0, t?.unsubscribe(a, i);
    };
  }, [e.current, t, o]), t?.observer;
}
function Qt() {
  let e = !1, n = [];
  const t = /* @__PURE__ */ new Map();
  if (typeof window > "u")
    return;
  const o = new ResizeObserver((s, a) => {
    n = n.concat(s), e || window.requestAnimationFrame(() => {
      const i = /* @__PURE__ */ new Set();
      for (let u = 0; u < n.length; u++) {
        if (i.has(n[u].target)) continue;
        i.add(n[u].target), t.get(n[u].target)?.forEach((h) => h(n[u], a));
      }
      n = [], e = !1;
    }), e = !0;
  });
  return {
    observer: o,
    subscribe(s, a) {
      o.observe(s);
      const i = t.get(s) ?? [];
      i.push(a), t.set(s, i);
    },
    unsubscribe(s, a) {
      const i = t.get(s) ?? [];
      if (i.length === 1) {
        o.unobserve(s), t.delete(s);
        return;
      }
      const u = i.indexOf(a);
      u !== -1 && i.splice(u, 1), t.set(s, i);
    }
  };
}
let me;
const Yt = () => me || (me = Qt()), Xt = (e) => {
  const [n, t] = r.useState({ width: 0, height: 0 });
  r.useLayoutEffect(() => {
    if (e.current) {
      const { width: s, height: a } = e.current.getBoundingClientRect();
      t({ width: s, height: a });
    }
  }, [e.current]);
  const o = r.useCallback(
    (s) => t(s.contentRect),
    []
  );
  return Kt(e, o), n;
};
function A(e, n, t = !0) {
  const [o, s] = r.useState(n);
  return r.useEffect(() => {
    if (t && s(n), typeof window > "u" || !e) return;
    const a = e.subscribe(s);
    return () => a.unsubscribe();
  }, [e, t]), o;
}
function Un(e) {
  const n = (a) => typeof window < "u" ? window.matchMedia(a).matches : !1, [t, o] = r.useState(n(e));
  function s() {
    o(n(e));
  }
  return r.useEffect(() => {
    const a = window.matchMedia(e);
    return s(), a.addListener ? a.addListener(s) : a.addEventListener("change", s), () => {
      a.removeListener ? a.removeListener(s) : a.removeEventListener("change", s);
    };
  }, [e]), t;
}
function zn(e) {
  const n = U(e), t = r.useCallback(async () => {
    await n.startAudio();
  }, [n]), o = r.useMemo(
    () => $e(n),
    [n]
  ), { canPlayAudio: s } = A(o, {
    canPlayAudio: n.canPlaybackAudio
  });
  return { canPlayAudio: s, startAudio: t };
}
function Hn(e) {
  const { state: n, dispatch: t } = _e().pin;
  return { buttonProps: r.useMemo(() => {
    const { className: s } = Ge();
    return J(e, {
      className: s,
      disabled: !n?.length,
      onClick: () => {
        t && t({ msg: "clear_pin" });
      }
    });
  }, [e, t, n]) };
}
function Vn(e = {}) {
  const n = X(e.participant), { className: t, connectionQualityObserver: o } = r.useMemo(
    () => Je(n),
    [n]
  ), s = A(o, n.connectionQuality);
  return { className: t, quality: s };
}
function oe(e) {
  const n = U(e), t = r.useMemo(() => Ke(n), [n]);
  return A(t, n.state);
}
function jn(e, n) {
  const t = typeof e == "function" ? e : n, o = typeof e == "string" ? e : void 0, s = de(), { send: a, messageObservable: i, isSendingObservable: u } = r.useMemo(
    () => Qe(s, o, t),
    [s, o, t]
  ), l = A(i, void 0), h = A(u, !1);
  return {
    message: l,
    send: a,
    isSending: h
  };
}
function Bn(e) {
  const n = de(), t = oe(n);
  return { buttonProps: r.useMemo(() => {
    const { className: s, disconnect: a } = Ye(n);
    return J(e, {
      className: s,
      onClick: () => a(e.stopTracks ?? !0),
      disabled: t === I.Disconnected
    });
  }, [n, e, t]) };
}
function Zt(e) {
  if (e.publication instanceof Vt) {
    const n = e.publication.track;
    if (n) {
      const { facingMode: t } = jt(n);
      return t;
    }
  }
  return "undefined";
}
function qn({ trackRef: e, props: n }) {
  const t = be(e), o = Xe(), { className: s } = r.useMemo(() => Ze(), []), a = r.useMemo(() => et(t, o?.pin.state), [t, o?.pin.state]);
  return { mergedProps: r.useMemo(
    () => J(n, {
      className: s,
      onClick: (u) => {
        n.onClick?.(u), a ? o?.pin.dispatch?.({
          msg: "clear_pin"
        }) : o?.pin.dispatch?.({
          msg: "set_pin",
          trackReference: t
        });
      }
    }),
    [n, s, t, a, o?.pin]
  ), inFocus: a };
}
function Wn(e, n, t = {}) {
  const o = t.gridLayouts ?? tt, { width: s, height: a } = Xt(e), i = nt(o, n, s, a);
  return r.useEffect(() => {
    e.current && i && (e.current.style.setProperty("--lk-col-count", i?.columns.toString()), e.current.style.setProperty("--lk-row-count", i?.rows.toString()));
  }, [e, i]), {
    layout: i,
    containerWidth: s,
    containerHeight: a
  };
}
function Pe(e, n = {}) {
  const t = typeof e == "string" ? n.participant : e.participant, o = X(t), s = typeof e == "string" ? { participant: o, source: e } : e, [a, i] = r.useState(
    !!(s.publication?.isMuted || o.getTrackPublication(s.source)?.isMuted)
  );
  return r.useEffect(() => {
    const u = rt(s).subscribe(i);
    return () => u.unsubscribe();
  }, [ge(s)]), a;
}
function en(e) {
  const n = X(e), t = r.useMemo(() => st(n), [n]);
  return A(t, n.isSpeaking);
}
function Ve(e = {}) {
  const n = U(e.room), [t, o] = r.useState(n.localParticipant), [s, a] = r.useState(
    t.isMicrophoneEnabled
  ), [i, u] = r.useState(t.isCameraEnabled), [l, h] = r.useState(
    t.isScreenShareEnabled
  ), [m, d] = r.useState(
    t.lastMicrophoneError
  ), [c, g] = r.useState(t.lastCameraError), [k, M] = r.useState(
    void 0
  ), [T, w] = r.useState(void 0), O = (L) => {
    u(L.isCameraEnabled), a(L.isMicrophoneEnabled), h(L.isScreenShareEnabled), w(L.cameraTrack), M(L.microphoneTrack), d(L.participant.lastMicrophoneError), g(L.participant.lastCameraError), o(L.participant);
  };
  return r.useEffect(() => {
    const L = ot(n.localParticipant).subscribe(O);
    return () => L.unsubscribe();
  }, [n]), {
    isMicrophoneEnabled: s,
    isScreenShareEnabled: l,
    isCameraEnabled: i,
    microphoneTrack: k,
    cameraTrack: T,
    lastMicrophoneError: m,
    lastCameraError: c,
    localParticipant: t
  };
}
function $n() {
  const e = de(), n = r.useMemo(
    () => xe(e.localParticipant),
    [e]
  );
  return A(n, e.localParticipant.permissions);
}
function Gn({
  kind: e,
  room: n,
  track: t,
  requestPermissions: o,
  onError: s
}) {
  const a = ve(), i = r.useMemo(() => n ?? a ?? new He(), [n, a]), u = r.useMemo(
    () => Fe(e, s, o),
    [e, o, s]
  ), l = A(u, []), [h, m] = r.useState(
    i?.getActiveDevice(e) ?? "default"
  ), { className: d, activeDeviceObservable: c, setActiveMediaDevice: g } = r.useMemo(
    () => at(e, i, t),
    [e, i, t]
  );
  return r.useEffect(() => {
    const k = c.subscribe((M) => {
      M && (V.info("setCurrentDeviceId", M), m(M));
    });
    return () => {
      k?.unsubscribe();
    };
  }, [c]), { devices: l, className: d, activeDeviceId: h, setActiveMediaDevice: g };
}
function Jn({
  kind: e,
  onError: n
}) {
  const t = r.useMemo(
    () => Fe(e, n),
    [e, n]
  );
  return A(t, []);
}
function tn(e, n, t = {}) {
  const o = r.useRef([]), s = r.useRef(-1), a = n !== s.current, i = typeof t.customSortFunction == "function" ? t.customSortFunction(e) : it(e);
  let u = [...i];
  if (a === !1)
    try {
      u = ct(o.current, i, n);
    } catch (l) {
      V.error("Error while running updatePages(): ", l);
    }
  return a ? o.current = i : o.current = u, s.current = n, u;
}
function Kn(e, n) {
  const [t, o] = r.useState(1), s = Math.max(Math.ceil(n.length / e), 1);
  t > s && o(s);
  const a = t * e, i = a - e, u = (d) => {
    o((c) => d === "next" ? c === s ? c : c + 1 : c === 1 ? c : c - 1);
  }, l = (d) => {
    d > s ? o(s) : d < 1 ? o(1) : o(d);
  }, m = tn(n, e).slice(i, a);
  return {
    totalPageCount: s,
    nextPage: () => u("next"),
    prevPage: () => u("previous"),
    setPage: l,
    firstItemIndex: i,
    lastItemIndex: a,
    tracks: m,
    currentPage: t
  };
}
function nn(e = {}) {
  let n = ye();
  e.participant && (n = e.participant);
  const t = r.useMemo(() => ut(n), [n]), { identity: o, name: s, metadata: a } = A(t, {
    name: n?.name,
    identity: n?.identity,
    metadata: n?.metadata
  });
  return { identity: o, name: s, metadata: a };
}
function Qn(e = {}) {
  const n = X(e.participant), t = r.useMemo(() => xe(n), [n]);
  return A(t, n.permissions);
}
function Yn({
  trackRef: e,
  onParticipantClick: n,
  disableSpeakingIndicator: t,
  htmlProps: o
}) {
  const s = be(e), a = r.useMemo(() => {
    const { className: c } = lt();
    return J(o, {
      className: c,
      onClick: (g) => {
        if (o.onClick?.(g), typeof n == "function") {
          const k = s.publication ?? s.participant.getTrackPublication(s.source);
          n({ participant: s.participant, track: k });
        }
      }
    });
  }, [
    o,
    n,
    s.publication,
    s.source,
    s.participant
  ]), i = s.participant.getTrackPublication(P.Source.Microphone), u = r.useMemo(() => ({
    participant: s.participant,
    source: P.Source.Microphone,
    publication: i
  }), [i, s.participant]), l = Pe(s), h = Pe(u), m = en(s.participant), d = Zt(s);
  return {
    elementProps: {
      "data-lk-audio-muted": h,
      "data-lk-video-muted": l,
      "data-lk-speaking": t === !0 ? !1 : m,
      "data-lk-local-participant": s.participant.isLocal,
      "data-lk-source": s.source,
      "data-lk-facing-mode": d,
      ...a
    }
  };
}
function Ce(e = {}) {
  const n = U(e.room), [t, o] = r.useState([]);
  return r.useEffect(() => {
    const s = dt(n, {
      additionalRoomEvents: e.updateOnlyOn
    }).subscribe(o);
    return () => s.unsubscribe();
  }, [n, JSON.stringify(e.updateOnlyOn)]), t;
}
function rn(e = {}) {
  const n = Ce(e), { localParticipant: t } = Ve(e);
  return r.useMemo(
    () => [t, ...n],
    [t, n]
  );
}
function Xn(e) {
  return e = ft(e), r.useMemo(() => e?.pin.state !== void 0 && e.pin.state.length >= 1 ? e.pin.state : [], [e.pin.state]);
}
function Zn(e, n = {}) {
  const t = de(), [o] = r.useState(n.updateOnlyOn), s = r.useMemo(() => typeof e == "string" ? pt(t, e, {
    additionalEvents: o
  }) : mt(t, e, {
    additionalEvents: o
  }), [t, JSON.stringify(e), o]), [a, i] = r.useState({
    p: void 0
  });
  return r.useEffect(() => {
    const u = s.subscribe((l) => i({ p: l }));
    return () => u.unsubscribe();
  }, [s]), a.p;
}
function er(e = {}) {
  const n = U(e.room), t = r.useMemo(() => ht(n), [n]), { name: o, metadata: s } = A(t, {
    name: n.name,
    metadata: n.metadata
  });
  return { name: o, metadata: s };
}
function sn(e) {
  const n = U(e?.room), t = r.useMemo(() => bt(n), [n]);
  return A(t, n.activeSpeakers);
}
function tr(e) {
  const [n, t] = r.useState(
    Me(e)
  ), o = sn();
  return r.useEffect(() => {
    t(Me(e));
  }, [o, e]), n;
}
function nr({ room: e, props: n }) {
  const t = U(e), { className: o, roomAudioPlaybackAllowedObservable: s, handleStartAudioPlayback: a } = r.useMemo(
    () => gt(),
    []
  ), i = r.useMemo(
    () => s(t),
    [t, s]
  ), { canPlayAudio: u } = A(i, {
    canPlayAudio: t.canPlaybackAudio
  });
  return { mergedProps: r.useMemo(
    () => J(n, {
      className: o,
      onClick: () => {
        a(t);
      },
      style: { display: u ? "none" : "block" }
    }),
    [n, o, u, a, t]
  ), canPlayAudio: u };
}
function rr({ room: e, props: n }) {
  const t = U(e), { className: o, roomVideoPlaybackAllowedObservable: s, handleStartVideoPlayback: a } = r.useMemo(
    () => vt(),
    []
  ), i = r.useMemo(
    () => s(t),
    [t, s]
  ), { canPlayVideo: u } = A(i, {
    canPlayVideo: t.canPlaybackVideo
  });
  return { mergedProps: r.useMemo(
    () => J(n, {
      className: o,
      onClick: () => {
        a(t);
      },
      style: { display: u ? "none" : "block" }
    }),
    [n, o, u, a, t]
  ), canPlayVideo: u };
}
function sr(e, n = {}) {
  const t = r.useRef(null), o = r.useRef(null), s = n.minSwipeDistance ?? 50, a = (l) => {
    o.current = null, t.current = l.targetTouches[0].clientX;
  }, i = (l) => {
    o.current = l.targetTouches[0].clientX;
  }, u = r.useCallback(() => {
    if (!t.current || !o.current)
      return;
    const l = t.current - o.current, h = l > s, m = l < -s;
    h && n.onLeftSwipe && n.onLeftSwipe(), m && n.onRightSwipe && n.onRightSwipe();
  }, [s, n]);
  r.useEffect(() => {
    const l = e.current;
    return l && (l.addEventListener("touchstart", a, { passive: !0 }), l.addEventListener("touchmove", i, { passive: !0 }), l.addEventListener("touchend", u, { passive: !0 })), () => {
      l && (l.removeEventListener("touchstart", a), l.removeEventListener("touchmove", i), l.removeEventListener("touchend", u));
    };
  }, [e, u]);
}
function or({ props: e }) {
  const { dispatch: n, state: t } = _e().widget, { className: o } = r.useMemo(() => yt(), []);
  return { mergedProps: r.useMemo(() => J(e, {
    className: o,
    onClick: () => {
      n && n({ msg: "toggle_chat" });
    },
    "aria-pressed": t?.showChat ? "true" : "false",
    "data-lk-unread-msgs": t ? t.unreadMessages < 10 ? t.unreadMessages.toFixed(0) : "9+" : "0"
  }), [e, o, n, t]) };
}
function ar(e, n, t = {}) {
  const [o, s] = r.useState(void 0);
  return r.useEffect(() => {
    if (e === void 0)
      throw Error("token endpoint needs to be defined");
    if (t.userInfo?.identity === void 0)
      return;
    (async () => {
      V.debug("fetching token");
      const i = new URLSearchParams({ ...t.userInfo, roomName: n }), u = await fetch(`${e}?${i.toString()}`);
      if (!u.ok) {
        V.error(
          `Could not fetch token. Server responded with status ${u.status}: ${u.statusText}`
        );
        return;
      }
      const { accessToken: l } = await u.json();
      s(l);
    })();
  }, [e, n, JSON.stringify(t)]), o;
}
function ir(e) {
  const n = be(e), { className: t, mediaMutedObserver: o } = r.useMemo(
    () => St(n),
    [ge(n)]
  );
  return { isMuted: A(
    o,
    !!(n.publication?.isMuted || n.participant.getTrackPublication(n.source)?.isMuted)
  ), className: t };
}
function cr({
  source: e,
  onChange: n,
  initialState: t,
  captureOptions: o,
  publishOptions: s,
  onDeviceError: a,
  room: i,
  ...u
}) {
  const l = ve(), h = r.useMemo(() => i ?? l, [i, l]), m = h?.localParticipant?.getTrackPublication(e), d = r.useRef(!1), { toggle: c, className: g, pendingObserver: k, enabledObserver: M } = r.useMemo(
    () => h ? Ct(e, h, o, s, a) : kt(),
    [h, e, JSON.stringify(o), s]
  ), T = A(k, !1), w = A(M, t ?? !!m?.isEnabled);
  r.useEffect(() => {
    n?.(w, d.current), d.current = !1;
  }, [w, n]), r.useEffect(() => {
    t !== void 0 && (V.debug("forcing initial toggle state", e, t), c(t));
  }, []);
  const O = r.useMemo(() => J(u, { className: g }), [u, g]), L = r.useCallback(
    (p) => {
      d.current = !0, c().catch(() => d.current = !1), u.onClick?.(p);
    },
    [u, c]
  );
  return {
    toggle: c,
    enabled: w,
    pending: T,
    track: m,
    buttonProps: {
      ...O,
      "aria-pressed": w,
      "data-lk-source": e,
      "data-lk-enabled": w,
      disabled: T,
      onClick: L
    }
  };
}
function ur(e = [
  P.Source.Camera,
  P.Source.Microphone,
  P.Source.ScreenShare,
  P.Source.ScreenShareAudio,
  P.Source.Unknown
], n = {}) {
  const t = U(n.room), [o, s] = r.useState([]), [a, i] = r.useState([]), u = r.useMemo(() => e.map((h) => Et(h) ? h.source : h), [JSON.stringify(e)]);
  return r.useEffect(() => {
    const h = Tt(t, u, {
      additionalRoomEvents: n.updateOnlyOn,
      onlySubscribed: n.onlySubscribed
    }).subscribe(({ trackReferences: m, participants: d }) => {
      V.debug("setting track bundles", m, d), s(m), i(d);
    });
    return () => h.unsubscribe();
  }, [
    t,
    JSON.stringify(n.onlySubscribed),
    JSON.stringify(n.updateOnlyOn),
    JSON.stringify(e)
  ]), r.useMemo(() => {
    if (Ue(e)) {
      const h = an(e, a), m = Array.from(o);
      return a.forEach((d) => {
        h.has(d.identity) && (h.get(d.identity) ?? []).forEach((g) => {
          if (o.find(
            ({ participant: M, publication: T }) => d.identity === M.identity && T.source === g
          ))
            return;
          V.debug(
            `Add ${g} placeholder for participant ${d.identity}.`
          );
          const k = {
            participant: d,
            source: g
          };
          m.push(k);
        });
      }), m;
    } else
      return o;
  }, [o, a, e]);
}
function on(e, n) {
  const t = new Set(e);
  for (const o of n)
    t.delete(o);
  return t;
}
function an(e, n) {
  const t = /* @__PURE__ */ new Map();
  if (Ue(e)) {
    const o = e.filter((s) => s.withPlaceholder).map((s) => s.source);
    n.forEach((s) => {
      const a = s.getTrackPublications().map((u) => u.track?.source).filter((u) => u !== void 0), i = Array.from(
        on(new Set(o), new Set(a))
      );
      i.length > 0 && t.set(s.identity, i);
    });
  }
  return t;
}
function cn(e) {
  const [n, t] = r.useState(Mt(e)), { trackObserver: o } = r.useMemo(() => wt(e), [e.participant.sid ?? e.participant.identity, e.source]);
  return r.useEffect(() => {
    const s = o.subscribe((a) => {
      t(a);
    });
    return () => s?.unsubscribe();
  }, [o]), {
    participant: e.participant,
    source: e.source ?? P.Source.Unknown,
    publication: n
  };
}
function lr(e, n) {
  const t = X(n);
  return cn({ name: e, participant: t });
}
function un(e) {
  const n = U(e?.room), t = oe(n), o = r.useMemo(
    () => t === I.Disconnected,
    [t]
  ), s = r.useMemo(
    () => Pt(n, e),
    [n, e, o]
  ), a = A(s.isSendingObservable, !1), i = A(s.messageObservable, []);
  return { send: s.send, chatMessages: i, isSending: a };
}
function dr(e = {}) {
  const [n, t] = r.useState(
    Rt(e.defaults, e.preventLoad ?? !1)
  ), o = r.useCallback((l) => {
    t((h) => ({ ...h, audioEnabled: l }));
  }, []), s = r.useCallback((l) => {
    t((h) => ({ ...h, videoEnabled: l }));
  }, []), a = r.useCallback((l) => {
    t((h) => ({ ...h, audioDeviceId: l }));
  }, []), i = r.useCallback((l) => {
    t((h) => ({ ...h, videoDeviceId: l }));
  }, []), u = r.useCallback((l) => {
    t((h) => ({ ...h, username: l }));
  }, []);
  return r.useEffect(() => {
    Lt(n, e.preventSave ?? !1);
  }, [n, e.preventSave]), {
    userChoices: n,
    saveAudioInputEnabled: o,
    saveVideoInputEnabled: s,
    saveAudioInputDeviceId: a,
    saveVideoInputDeviceId: i,
    saveUsername: u
  };
}
function fr(e, n = {}) {
  const t = X(e), o = U(n.room), s = r.useMemo(() => At(o, t), [o, t]);
  return A(
    s,
    t.isLocal ? t.isE2EEEnabled : !!t?.isEncrypted
  );
}
function pr(e, n = { fftSize: 32, smoothingTimeConstant: 0 }) {
  const t = Ot(e) ? e.publication.track : e, [o, s] = r.useState(0);
  return r.useEffect(() => {
    if (!t || !t.mediaStream)
      return;
    const { cleanup: a, analyser: i } = Se(t, n), u = i.frequencyBinCount, l = new Uint8Array(u), m = setInterval(() => {
      i.getByteFrequencyData(l);
      let d = 0;
      for (let c = 0; c < l.length; c++) {
        const g = l[c];
        d += g * g;
      }
      s(Math.sqrt(d / l.length) / 255);
    }, 1e3 / 30);
    return () => {
      a(), clearInterval(m);
    };
  }, [t, t?.mediaStream, JSON.stringify(n)]), o;
}
const ln = (e) => {
  const n = (t) => {
    let a = 1 - Math.max(-100, Math.min(-10, t)) * -1 / 100;
    return a = Math.sqrt(a), a;
  };
  return e.map((t) => t === -1 / 0 ? 0 : n(t));
}, dn = {
  bands: 5,
  loPass: 100,
  hiPass: 600,
  updateInterval: 32,
  analyserOptions: { fftSize: 2048 }
};
function mr(e, n = {}) {
  const t = e instanceof P ? e : e?.publication?.track, o = { ...dn, ...n }, [s, a] = r.useState(
    new Array(o.bands).fill(0)
  );
  return r.useEffect(() => {
    if (!t || !t?.mediaStream) {
      a((c) => c.slice().fill(0));
      return;
    }
    const { analyser: i, cleanup: u } = Se(t, o.analyserOptions), l = i.frequencyBinCount, h = new Float32Array(l), d = setInterval(() => {
      i.getFloatFrequencyData(h);
      let c = new Float32Array(h.length);
      for (let T = 0; T < h.length; T++)
        c[T] = h[T];
      c = c.slice(o.loPass, o.hiPass);
      const g = ln(c), k = g.length, M = [];
      for (let T = 0; T < o.bands; T++) {
        const w = Math.floor(T * k / o.bands), O = Math.floor((T + 1) * k / o.bands), L = g.slice(w, O), p = L.length;
        if (p === 0)
          M.push(0);
        else {
          const f = L.reduce((b, v) => b += v, 0);
          M.push(f / p);
        }
      }
      a(M);
    }, o.updateInterval);
    return () => {
      u(), clearInterval(d);
    };
  }, [t, t?.mediaStream, JSON.stringify(n)]), s;
}
const fn = {
  barCount: 120,
  volMultiplier: 5,
  updateInterval: 20
};
function hr(e, n = {}) {
  const t = e instanceof P ? e : e?.publication?.track, o = { ...fn, ...n }, s = r.useRef(new Float32Array()), a = r.useRef(performance.now()), i = r.useRef(0), [u, l] = r.useState([]), h = r.useCallback((m) => {
    l(
      Array.from(
        mn(m, o.barCount).map((d) => Math.sqrt(d) * o.volMultiplier)
        // wave.slice(0, opts.barCount).map((v) => sigmoid(v * opts.volMultiplier, 0.08, 0.2)),
      )
    );
  }, []);
  return r.useEffect(() => {
    if (!t || !t?.mediaStream)
      return;
    const { analyser: m, cleanup: d } = Se(t, {
      fftSize: Re(o.barCount)
    }), c = Re(o.barCount), g = new Float32Array(c), k = () => {
      if (M = requestAnimationFrame(k), m.getFloatTimeDomainData(g), s.current.map((T, w) => T + g[w]), i.current += 1, performance.now() - a.current >= o.updateInterval) {
        const T = g.map((w) => w / i.current);
        h(T), a.current = performance.now(), i.current = 0;
      }
    };
    let M = requestAnimationFrame(k);
    return () => {
      d(), cancelAnimationFrame(M);
    };
  }, [t, t?.mediaStream, JSON.stringify(n), h]), {
    bars: u
  };
}
function Re(e) {
  return e < 32 ? 32 : pn(e);
}
function pn(e) {
  let n = 2;
  for (; e >>= 1; )
    n <<= 1;
  return n;
}
function mn(e, n) {
  const t = Math.floor(e.length / n), o = new Float32Array(n);
  for (let s = 0; s < n; s++) {
    const a = t * s;
    let i = 0;
    for (let u = 0; u < t; u++)
      i = i + Math.abs(e[a + u]);
    o[s] = i / t;
  }
  return o;
}
function le(e, n = {}) {
  let t, o;
  typeof n == "string" ? t = n : (t = n?.participantIdentity, o = n?.room);
  const s = ye(), a = rn({ room: o, updateOnlyOn: [] }), i = r.useMemo(() => t ? a.find((h) => h.identity === t) : s, [t, a, s]), u = r.useMemo(() => {
    if (i)
      return It(i, { sources: e });
  }, [i, JSON.stringify(e)]);
  return A(u, []);
}
function hn(e) {
  const n = r.useMemo(
    () => e?.publication?.track ? Dt(e?.publication.track) : void 0,
    [e?.publication?.track]
  );
  return A(n, {
    timestamp: Date.now(),
    rtpTimestamp: e?.publication?.track?.rtpTimestamp
  });
}
const bn = {
  bufferSize: 100
  // maxAge: 2_000,
};
function gn(e, n) {
  const t = { ...bn, ...n }, [o, s] = r.useState([]), a = hn(e), i = (u) => {
    t.onTranscription?.(u), s(
      (l) => _t(
        l,
        // when first receiving a segment, add the current media timestamp to it
        u.map((h) => xt(h, a)),
        t.bufferSize
      )
    );
  };
  return r.useEffect(() => {
    if (!e?.publication)
      return;
    const u = Nt(e.publication).subscribe((l) => {
      i(...l);
    });
    return () => {
      u.unsubscribe();
    };
  }, [e && ge(e), i]), { segments: o };
}
function vn(e = {}) {
  const n = ye(), t = e.participant ?? n, o = r.useMemo(
    // weird typescript constraint
    () => t ? he(t) : he(t),
    [t]
  );
  return A(o, {
    attributes: t?.attributes
  });
}
function br(e, n = {}) {
  const t = X(n.participant), [o, s] = r.useState(t.attributes[e]);
  return r.useEffect(() => {
    if (!t)
      return;
    const a = he(t).subscribe((i) => {
      i.changed[e] !== void 0 && s(i.attributes[e]);
    });
    return () => {
      a.unsubscribe();
    };
  }, [t, e]), o;
}
const Le = G.AgentState;
function gr() {
  const e = Ce(), n = e.find(
    (d) => d.kind === ue.AGENT && !(G.PublishOnBehalf in d.attributes)
  ), t = e.find(
    (d) => d.kind === ue.AGENT && d.attributes[G.PublishOnBehalf] === n?.identity
  ), o = le(
    [P.Source.Microphone, P.Source.Camera],
    n?.identity
  ), s = le(
    [P.Source.Microphone, P.Source.Camera],
    t?.identity
  ), a = o.find((d) => d.source === P.Source.Microphone) ?? s.find((d) => d.source === P.Source.Microphone), i = o.find((d) => d.source === P.Source.Camera) ?? s.find((d) => d.source === P.Source.Camera), { segments: u } = gn(a), l = oe(), { attributes: h } = vn({ participant: n }), m = r.useMemo(() => l === I.Disconnected ? "disconnected" : l === I.Connecting || !n || !h?.[Le] ? "connecting" : h[Le], [h, n, l]);
  return {
    agent: n,
    state: m,
    audioTrack: a,
    videoTrack: i,
    agentTranscriptions: u,
    agentAttributes: h
  };
}
function vr(e) {
  const n = U(e), t = oe(n), o = r.useMemo(() => Ft(n), [n, t]);
  return A(o, n.isRecording);
}
function yn(e, n) {
  const t = U(n?.room), s = oe(t) === I.Disconnected, a = r.useMemo(() => Ut(t, e), [t, e]);
  return { textStreams: A(s ? void 0 : a, []) };
}
function Sn(e) {
  const { participantIdentities: n, trackSids: t } = e ?? {}, { textStreams: o } = yn(zt.TRANSCRIPTION, { room: e?.room });
  return r.useMemo(
    () => o.filter(
      (a) => n ? n.includes(a.participantInfo.identity) : !0
    ).filter(
      (a) => t ? t.includes(
        a.streamInfo.attributes?.[G.TranscribedTrackId] ?? ""
      ) : !0
    ),
    [o, n, t]
  );
}
const Ae = 2, Oe = 400, Ie = 3, De = 1e3;
function yr(e) {
  const n = pe([]), t = qe(() => new Bt(), []), o = se(async () => t.lock().then(async (m) => {
    for (; ; ) {
      const d = n.current.pop();
      if (!d) {
        m();
        break;
      }
      switch (d.type) {
        case "connect":
          await d.room.connect(...d.args).then(d.resolve).catch(d.reject);
          break;
        case "disconnect":
          await d.room.disconnect(...d.args).then(d.resolve).catch(d.reject);
          break;
      }
    }
  }), []), s = pe([]), a = se((m) => {
    let d = 0;
    s.current = s.current.filter((c) => {
      const g = m.getTime() - c.getTime() < De;
      return g && (d += 1), g;
    }), d > Ie && V.warn(
      `useSequentialRoomConnectDisconnect: room changed reference rapidly (over ${Ie}x in ${De}ms). This is not recommended.`
    );
  }, []);
  We(() => {
    n.current = [];
    const m = /* @__PURE__ */ new Date();
    s.current.push(m), a(m);
  }, [e, a]);
  const i = pe([]), u = se((m) => {
    let d = 0;
    i.current = i.current.filter((c) => {
      const g = m.getTime() - c.getTime() < Oe;
      return g && (d += 1), g;
    }), d > Ae && V.warn(
      `useSequentialRoomConnectDisconnect: room connect / disconnect occurring in rapid sequence (over ${Ae}x in ${Oe}ms). This is not recommended and may be the sign of a bug like a useEffect dependency changing every render.`
    );
  }, []), l = se(
    async (...m) => new Promise((d, c) => {
      if (!e)
        throw new Error("Called connect(), but room was unset");
      const g = /* @__PURE__ */ new Date();
      u(g), n.current.push({ type: "connect", room: e, args: m, resolve: d, reject: c }), i.current.push(g), o();
    }),
    [e, u, o]
  ), h = se(
    async (...m) => new Promise((d, c) => {
      if (!e)
        throw new Error("Called discconnect(), but room was unset");
      const g = /* @__PURE__ */ new Date();
      u(g), n.current.push({ type: "disconnect", room: e, args: m, resolve: d, reject: c }), i.current.push(g), o();
    }),
    [e, u, o]
  );
  return {
    connect: e ? l : null,
    disconnect: e ? h : null
  };
}
var ce = { exports: {} }, Ne;
function Cn() {
  if (Ne) return ce.exports;
  Ne = 1;
  var e = typeof Reflect == "object" ? Reflect : null, n = e && typeof e.apply == "function" ? e.apply : function(f, b, v) {
    return Function.prototype.apply.call(f, b, v);
  }, t;
  e && typeof e.ownKeys == "function" ? t = e.ownKeys : Object.getOwnPropertySymbols ? t = function(f) {
    return Object.getOwnPropertyNames(f).concat(Object.getOwnPropertySymbols(f));
  } : t = function(f) {
    return Object.getOwnPropertyNames(f);
  };
  function o(p) {
    console && console.warn && console.warn(p);
  }
  var s = Number.isNaN || function(f) {
    return f !== f;
  };
  function a() {
    a.init.call(this);
  }
  ce.exports = a, ce.exports.once = w, a.EventEmitter = a, a.prototype._events = void 0, a.prototype._eventsCount = 0, a.prototype._maxListeners = void 0;
  var i = 10;
  function u(p) {
    if (typeof p != "function")
      throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof p);
  }
  Object.defineProperty(a, "defaultMaxListeners", {
    enumerable: !0,
    get: function() {
      return i;
    },
    set: function(p) {
      if (typeof p != "number" || p < 0 || s(p))
        throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + p + ".");
      i = p;
    }
  }), a.init = function() {
    (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, a.prototype.setMaxListeners = function(f) {
    if (typeof f != "number" || f < 0 || s(f))
      throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + f + ".");
    return this._maxListeners = f, this;
  };
  function l(p) {
    return p._maxListeners === void 0 ? a.defaultMaxListeners : p._maxListeners;
  }
  a.prototype.getMaxListeners = function() {
    return l(this);
  }, a.prototype.emit = function(f) {
    for (var b = [], v = 1; v < arguments.length; v++) b.push(arguments[v]);
    var C = f === "error", R = this._events;
    if (R !== void 0)
      C = C && R.error === void 0;
    else if (!C)
      return !1;
    if (C) {
      var y;
      if (b.length > 0 && (y = b[0]), y instanceof Error)
        throw y;
      var N = new Error("Unhandled error." + (y ? " (" + y.message + ")" : ""));
      throw N.context = y, N;
    }
    var x = R[f];
    if (x === void 0)
      return !1;
    if (typeof x == "function")
      n(x, this, b);
    else
      for (var j = x.length, z = k(x, j), v = 0; v < j; ++v)
        n(z[v], this, b);
    return !0;
  };
  function h(p, f, b, v) {
    var C, R, y;
    if (u(b), R = p._events, R === void 0 ? (R = p._events = /* @__PURE__ */ Object.create(null), p._eventsCount = 0) : (R.newListener !== void 0 && (p.emit(
      "newListener",
      f,
      b.listener ? b.listener : b
    ), R = p._events), y = R[f]), y === void 0)
      y = R[f] = b, ++p._eventsCount;
    else if (typeof y == "function" ? y = R[f] = v ? [b, y] : [y, b] : v ? y.unshift(b) : y.push(b), C = l(p), C > 0 && y.length > C && !y.warned) {
      y.warned = !0;
      var N = new Error("Possible EventEmitter memory leak detected. " + y.length + " " + String(f) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      N.name = "MaxListenersExceededWarning", N.emitter = p, N.type = f, N.count = y.length, o(N);
    }
    return p;
  }
  a.prototype.addListener = function(f, b) {
    return h(this, f, b, !1);
  }, a.prototype.on = a.prototype.addListener, a.prototype.prependListener = function(f, b) {
    return h(this, f, b, !0);
  };
  function m() {
    if (!this.fired)
      return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
  }
  function d(p, f, b) {
    var v = { fired: !1, wrapFn: void 0, target: p, type: f, listener: b }, C = m.bind(v);
    return C.listener = b, v.wrapFn = C, C;
  }
  a.prototype.once = function(f, b) {
    return u(b), this.on(f, d(this, f, b)), this;
  }, a.prototype.prependOnceListener = function(f, b) {
    return u(b), this.prependListener(f, d(this, f, b)), this;
  }, a.prototype.removeListener = function(f, b) {
    var v, C, R, y, N;
    if (u(b), C = this._events, C === void 0)
      return this;
    if (v = C[f], v === void 0)
      return this;
    if (v === b || v.listener === b)
      --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete C[f], C.removeListener && this.emit("removeListener", f, v.listener || b));
    else if (typeof v != "function") {
      for (R = -1, y = v.length - 1; y >= 0; y--)
        if (v[y] === b || v[y].listener === b) {
          N = v[y].listener, R = y;
          break;
        }
      if (R < 0)
        return this;
      R === 0 ? v.shift() : M(v, R), v.length === 1 && (C[f] = v[0]), C.removeListener !== void 0 && this.emit("removeListener", f, N || b);
    }
    return this;
  }, a.prototype.off = a.prototype.removeListener, a.prototype.removeAllListeners = function(f) {
    var b, v, C;
    if (v = this._events, v === void 0)
      return this;
    if (v.removeListener === void 0)
      return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : v[f] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete v[f]), this;
    if (arguments.length === 0) {
      var R = Object.keys(v), y;
      for (C = 0; C < R.length; ++C)
        y = R[C], y !== "removeListener" && this.removeAllListeners(y);
      return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
    }
    if (b = v[f], typeof b == "function")
      this.removeListener(f, b);
    else if (b !== void 0)
      for (C = b.length - 1; C >= 0; C--)
        this.removeListener(f, b[C]);
    return this;
  };
  function c(p, f, b) {
    var v = p._events;
    if (v === void 0)
      return [];
    var C = v[f];
    return C === void 0 ? [] : typeof C == "function" ? b ? [C.listener || C] : [C] : b ? T(C) : k(C, C.length);
  }
  a.prototype.listeners = function(f) {
    return c(this, f, !0);
  }, a.prototype.rawListeners = function(f) {
    return c(this, f, !1);
  }, a.listenerCount = function(p, f) {
    return typeof p.listenerCount == "function" ? p.listenerCount(f) : g.call(p, f);
  }, a.prototype.listenerCount = g;
  function g(p) {
    var f = this._events;
    if (f !== void 0) {
      var b = f[p];
      if (typeof b == "function")
        return 1;
      if (b !== void 0)
        return b.length;
    }
    return 0;
  }
  a.prototype.eventNames = function() {
    return this._eventsCount > 0 ? t(this._events) : [];
  };
  function k(p, f) {
    for (var b = new Array(f), v = 0; v < f; ++v)
      b[v] = p[v];
    return b;
  }
  function M(p, f) {
    for (; f + 1 < p.length; f++)
      p[f] = p[f + 1];
    p.pop();
  }
  function T(p) {
    for (var f = new Array(p.length), b = 0; b < f.length; ++b)
      f[b] = p[b].listener || p[b];
    return f;
  }
  function w(p, f) {
    return new Promise(function(b, v) {
      function C(y) {
        p.removeListener(f, R), v(y);
      }
      function R() {
        typeof p.removeListener == "function" && p.removeListener("error", C), b([].slice.call(arguments));
      }
      L(p, f, R, { once: !0 }), f !== "error" && O(p, C, { once: !0 });
    });
  }
  function O(p, f, b) {
    typeof p.on == "function" && L(p, "error", f, b);
  }
  function L(p, f, b, v) {
    if (typeof p.on == "function")
      v.once ? p.once(f, b) : p.on(f, b);
    else if (typeof p.addEventListener == "function")
      p.addEventListener(f, function C(R) {
        v.once && p.removeEventListener(f, C), b(R);
      });
    else
      throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof p);
  }
  return ce.exports;
}
var ke = Cn();
const kn = 2e4;
var En = /* @__PURE__ */ ((e) => (e.CameraChanged = "cameraChanged", e.MicrophoneChanged = "microphoneChanged", e.StateChanged = "stateChanged", e))(En || {});
const F = (e) => ({
  isConnected: e === "listening" || e === "thinking" || e === "speaking",
  canListen: e === "pre-connect-buffering" || e === "listening" || e === "thinking" || e === "speaking",
  isFinished: e === "disconnected" || e === "failed",
  isPending: e === "connecting" || e === "initializing" || e === "idle"
}), Tn = () => {
  const [e, n] = r.useState(
    null
  ), [t, o] = r.useState(
    null
  ), s = r.useRef("connecting"), a = r.useRef(!1), i = (u) => setTimeout(() => {
    if (!a.current) {
      n("Agent did not join the room.");
      return;
    }
    const { isConnected: l } = F(s.current);
    if (!l) {
      n("Agent joined the room but did not complete initializing.");
      return;
    }
  }, u ?? kn);
  return {
    agentTimeoutFailureReason: e,
    startAgentTimeout: r.useCallback(
      (u) => {
        t && clearTimeout(t), n(null), o(i(u)), s.current = "connecting", a.current = !1;
      },
      [t]
    ),
    clearAgentTimeout: r.useCallback(() => {
      t && clearTimeout(t), n(null), o(null), s.current = "connecting", a.current = !1;
    }, [t]),
    clearAgentTimeoutFailureReason: r.useCallback(() => {
      n(null);
    }, []),
    updateAgentTimeoutState: r.useCallback((u) => {
      s.current = u;
    }, []),
    updateAgentTimeoutParticipantExists: r.useCallback((u) => {
      a.current = u;
    }, [])
  };
};
function Mn(e, n) {
  const t = r.useRef(n);
  r.useEffect(() => {
    t.current = n;
  }, [n]);
  const o = r.useCallback(
    async (i) => {
      const { isConnected: u } = F(t.current);
      if (!u)
        return new Promise((l, h) => {
          const m = (g) => {
            const { isConnected: k } = F(g);
            k && (c(), l());
          }, d = () => {
            c(), h(new Error("useAgent(/* ... */).waitUntilConnected - signal aborted"));
          }, c = () => {
            e.off("stateChanged", m), i?.removeEventListener("abort", d);
          };
          e.on("stateChanged", m), i?.addEventListener("abort", d);
        });
    },
    [e]
  ), s = r.useCallback(
    async (i) => {
      const { canListen: u } = F(t.current);
      if (!u)
        return new Promise((l, h) => {
          const m = (g) => {
            const { canListen: k } = F(g);
            k && (c(), l());
          }, d = () => {
            c(), h(new Error("useAgent(/* ... */).waitUntilCouldBeListening - signal aborted"));
          }, c = () => {
            e.off("stateChanged", m), i?.removeEventListener("abort", d);
          };
          e.on("stateChanged", m), i?.addEventListener("abort", d);
        });
    },
    [e]
  ), a = r.useCallback(
    async (i) => {
      const { isFinished: u } = F(t.current);
      if (!u)
        return new Promise((l, h) => {
          const m = (g) => {
            const { isFinished: k } = F(g);
            k && (c(), l());
          }, d = () => {
            c(), h(new Error("useAgent(/* ... */).waitUntilFinished - signal aborted"));
          }, c = () => {
            e.off("stateChanged", m), i?.removeEventListener("abort", d);
          };
          e.on("stateChanged", m), i?.addEventListener("abort", d);
        });
    },
    [e]
  );
  return { waitUntilConnected: o, waitUntilCouldBeListening: s, waitUntilFinished: a };
}
function je(e) {
  const n = Ht();
  if (e = e ?? n, !e)
    throw new Error(
      "No session provided, make sure you are inside a Session context or pass the session explicitly"
    );
  const {
    room: t,
    internal: {
      agentConnectTimeoutMilliseconds: o,
      agentTimeoutFailureReason: s,
      startAgentTimeout: a,
      clearAgentTimeout: i,
      clearAgentTimeoutFailureReason: u,
      updateAgentTimeoutState: l,
      updateAgentTimeoutParticipantExists: h
    }
  } = e, m = r.useMemo(() => new ke.EventEmitter(), []), d = Ce({ room: t }), c = r.useMemo(() => d.find(
    (S) => S.kind === ue.AGENT && !(G.PublishOnBehalf in S.attributes)
  ) ?? null, [d]), g = r.useMemo(() => c ? d.find(
    (S) => S.kind === ue.AGENT && S.attributes[G.PublishOnBehalf] === c.identity
  ) ?? null : null, [c, d]), k = c?.attributes ?? {}, M = le([P.Source.Camera, P.Source.Microphone], {
    room: t,
    participantIdentity: c?.identity
  }), T = le([P.Source.Camera, P.Source.Microphone], {
    room: t,
    participantIdentity: g?.identity
  }), w = r.useMemo(
    () => M.find((S) => S.source === P.Source.Camera) ?? T.find((S) => S.source === P.Source.Camera),
    [M, T]
  );
  r.useEffect(() => {
    m.emit("cameraChanged", w);
  }, [m, w]);
  const O = r.useMemo(
    () => M.find((S) => S.source === P.Source.Microphone) ?? T.find((S) => S.source === P.Source.Microphone),
    [M, T]
  );
  r.useEffect(() => {
    m.emit("microphoneChanged", O);
  }, [m, O]);
  const [L, p] = r.useState(t.state);
  r.useEffect(() => {
    const S = (_) => {
      p(_);
    };
    return t.on(H.ConnectionStateChanged, S), () => {
      t.off(H.ConnectionStateChanged, S);
    };
  }, [t]), r.useEffect(() => {
    c && u();
  }, [c]);
  const [f, b] = r.useState(null);
  r.useEffect(() => {
    if (!c)
      return;
    const S = (_) => {
      _.identity === c?.identity && b("Agent left the room unexpectedly.");
    };
    return t.on(H.ParticipantDisconnected, S), () => {
      t.off(H.ParticipantDisconnected, S);
    };
  }, [c, t]), r.useEffect(() => {
    L === I.Disconnected && b(null);
  }, [L]);
  const [v, C] = r.useState(
    () => t.localParticipant.getTrackPublication(P.Source.Microphone) ?? null
  );
  r.useEffect(() => {
    const S = () => {
      C(t.localParticipant.getTrackPublication(P.Source.Microphone) ?? null);
    }, _ = () => {
      C(null);
    };
    return t.localParticipant.on(
      ie.LocalTrackPublished,
      S
    ), t.localParticipant.on(
      ie.LocalTrackUnpublished,
      _
    ), () => {
      t.localParticipant.off(
        ie.LocalTrackPublished,
        S
      ), t.localParticipant.off(
        ie.LocalTrackUnpublished,
        _
      );
    };
  }, [t.localParticipant]);
  const R = r.useMemo(() => {
    const S = [];
    return s && S.push(s), f && S.push(f), S;
  }, [s, f]), y = r.useMemo(() => {
    if (R.length > 0)
      return "failed";
    let S = "disconnected";
    return L !== I.Disconnected && (S = "connecting"), v && (S = "pre-connect-buffering"), c && k[G.AgentState] && (S = k[G.AgentState]), S;
  }, [
    R,
    L,
    v,
    c,
    k
  ]);
  r.useEffect(() => {
    m.emit("stateChanged", y), l(y);
  }, [m, y]), r.useEffect(() => {
    h(c !== null);
  }, [c]);
  const N = e.connectionState === "disconnected";
  r.useEffect(() => {
    if (!N)
      return a(o), () => {
        i();
      };
  }, [N, o]);
  const {
    identity: x,
    name: j,
    metadata: z
  } = nn({ participant: c ?? void 0 }), B = r.useMemo(() => {
    const S = {
      attributes: k,
      internal: {
        agentParticipant: c,
        workerParticipant: g,
        emitter: m
      }
    };
    switch (y) {
      case "disconnected":
        return {
          ...S,
          identity: void 0,
          name: void 0,
          metadata: void 0,
          state: y,
          ...F(y),
          failureReasons: null,
          // Clear inner values if no longer connected
          cameraTrack: void 0,
          microphoneTrack: void 0
        };
      case "connecting":
        return {
          ...S,
          identity: void 0,
          name: void 0,
          metadata: void 0,
          state: y,
          ...F(y),
          failureReasons: null,
          // Clear inner values if no longer connected
          cameraTrack: void 0,
          microphoneTrack: void 0
        };
      case "initializing":
      case "idle":
        return {
          ...S,
          identity: x,
          name: j,
          metadata: z,
          state: y,
          ...F(y),
          failureReasons: null,
          cameraTrack: w,
          microphoneTrack: O
        };
      case "pre-connect-buffering":
        return {
          ...S,
          identity: x,
          name: j,
          metadata: z,
          state: y,
          ...F(y),
          failureReasons: null,
          cameraTrack: w,
          microphoneTrack: O
        };
      case "listening":
      case "thinking":
      case "speaking":
        return {
          ...S,
          identity: x,
          name: j,
          metadata: z,
          state: y,
          ...F(y),
          failureReasons: null,
          cameraTrack: w,
          microphoneTrack: O
        };
      case "failed":
        return {
          ...S,
          identity: void 0,
          name: void 0,
          metadata: void 0,
          state: "failed",
          ...F("failed"),
          failureReasons: R,
          // Clear inner values if no longer connected
          cameraTrack: void 0,
          microphoneTrack: void 0
        };
    }
  }, [
    x,
    j,
    z,
    k,
    m,
    c,
    y,
    w,
    O
  ]), { waitUntilConnected: K, waitUntilCouldBeListening: Q, waitUntilFinished: Y } = Mn(m, y), ne = r.useCallback(
    (S) => new Promise((_, Z) => {
      const $ = (D) => {
        D && (E(), _(D));
      }, q = () => {
        E(), Z(new Error("useAgent(/* ... */).waitUntilCamera - signal aborted"));
      }, E = () => {
        m.off("cameraChanged", $), S?.removeEventListener("abort", q);
      };
      m.on("cameraChanged", $), S?.addEventListener("abort", q);
    }),
    [m]
  ), re = r.useCallback(
    (S) => new Promise((_, Z) => {
      const $ = (D) => {
        D && (E(), _(D));
      }, q = () => {
        E(), Z(new Error("useAgent(/* ... */).waitUntilMicrophone - signal aborted"));
      }, E = () => {
        m.off("microphoneChanged", $), S?.removeEventListener("abort", q);
      };
      m.on("microphoneChanged", $), S?.addEventListener("abort", q);
    }),
    [m]
  );
  return r.useMemo(() => ({
    ...B,
    waitUntilConnected: K,
    waitUntilCouldBeListening: Q,
    waitUntilFinished: Y,
    waitUntilCamera: ne,
    waitUntilMicrophone: re
  }), [
    B,
    K,
    Q,
    Y,
    ne,
    re
  ]);
}
var wn = /* @__PURE__ */ ((e) => (e.ConnectionStateChanged = "connectionStateChanged", e.MediaDevicesError = "mediaDevicesError", e.EncryptionError = "encryptionError", e))(wn || {});
function Pn(e) {
  return typeof e == "object" && e !== null && "room" in e && "connectionState" in e && "internal" in e;
}
function Rn(e, n) {
  const t = /* @__PURE__ */ new Set([...Object.keys(e), ...Object.keys(n)]);
  for (const o of t)
    switch (o) {
      case "roomName":
      case "participantName":
      case "participantIdentity":
      case "participantMetadata":
      case "participantAttributes":
      case "agentName":
      case "agentMetadata":
        if (e[o] !== n[o])
          return !1;
        break;
      default:
        const s = o;
        throw new Error(`Options key ${s} not being checked for equality!`);
    }
  return !0;
}
function Ln(e, n) {
  const t = r.useRef(n);
  return r.useEffect(() => {
    t.current = n;
  }, [n]), r.useCallback(
    async (s, a) => {
      if (t.current !== s)
        return new Promise((i, u) => {
          const l = (d) => {
            d === s && (m(), i());
          }, h = () => {
            m(), u(
              new Error(
                `useSession(/* ... */).waitUntilConnectionState(${s}, /* signal */) - signal aborted`
              )
            );
          }, m = () => {
            e.off("connectionStateChanged", l), a?.removeEventListener("abort", h);
          };
          e.on("connectionStateChanged", l), a?.addEventListener("abort", h);
        });
    },
    [e]
  );
}
function An(e, n) {
  const t = e instanceof $t, o = r.useRef(
    t ? n : null
  );
  return r.useEffect(() => {
    if (!t) {
      o.current = null;
      return;
    }
    o.current !== null && Rn(o.current, n) || (o.current = n);
  }, [t, n]), r.useCallback(
    async (a) => {
      if (t) {
        if (!o.current)
          throw new Error(
            "AgentSession - memoized token fetch options are not set, but the passed tokenSource was an instance of TokenSourceConfigurable. If you are seeing this please make a new GitHub issue!"
          );
        return e.fetch(o.current, a);
      } else
        return e.fetch();
    },
    [t, e]
  );
}
function Sr(e, n = {}) {
  const {
    room: t,
    agentConnectTimeoutMilliseconds: o,
    encryption: s,
    ...a
  } = n, i = s && "e2eeManager" in s ? s.e2eeManager : null, u = s && !("e2eeManager" in s) ? s.key ?? null : null, l = s && !("e2eeManager" in s) ? s.worker ?? null : null, h = ve(), m = r.useRef(null), d = r.useMemo(() => typeof u == "string" || u instanceof ArrayBuffer ? (m.current === null && (m.current = new qt()), m.current.setKey(u).catch((E) => V.error(E)), m.current) : u, [u]), c = r.useMemo(() => {
    const E = h ?? t;
    if (E)
      return E;
    const D = !!(d && l), W = !!i, fe = D || W, ee = {};
    D ? ee.encryption = {
      keyProvider: d,
      worker: l
    } : W ? ee.encryption = {
      e2eeManager: i
    } : s !== void 0 && V.warn(
      "useSession options encryption was set, but neither encryption.key with encryption.worker nor encryption.e2eeManager was provided."
    );
    const ae = new He(ee);
    return fe && ae.setE2EEEnabled(!0), ae;
  }, [h, t, d, l, i]);
  r.useEffect(() => () => {
    c.disconnect();
  }, [c]);
  const g = r.useMemo(
    () => new ke.EventEmitter(),
    []
  ), k = r.useCallback(
    (E) => ({
      isConnected: E === I.Connected || E === I.Reconnecting || E === I.SignalReconnecting
    }),
    []
  ), [M, T] = r.useState(c.state);
  r.useEffect(() => {
    const E = (D) => {
      T(D);
    };
    return c.on(H.ConnectionStateChanged, E), () => {
      c.off(H.ConnectionStateChanged, E);
    };
  }, [c]), r.useEffect(() => {
    const E = async (D) => {
      g.emit("mediaDevicesError", D);
    };
    return c.on(H.MediaDevicesError, E), () => {
      c.off(H.MediaDevicesError, E);
    };
  }, [c, g]), r.useEffect(() => {
    const E = async (D) => {
      g.emit("encryptionError", D);
    };
    return c.on(H.EncryptionError, E), () => {
      c.off(H.EncryptionError, E);
    };
  }, [c, g]);
  const { localParticipant: w } = Ve({ room: c }), O = w.getTrackPublication(P.Source.Camera), L = r.useMemo(() => {
    if (O)
      return {
        source: P.Source.Camera,
        participant: w,
        publication: O
      };
  }, [w, O]), p = w.getTrackPublication(P.Source.Microphone), f = r.useMemo(() => {
    if (p)
      return {
        source: P.Source.Microphone,
        participant: w,
        publication: p
      };
  }, [w, p]), b = w.getTrackPublication(P.Source.ScreenShare), v = r.useMemo(() => {
    if (b)
      return {
        source: P.Source.ScreenShare,
        participant: w,
        publication: b
      };
  }, [w, b]), {
    agentTimeoutFailureReason: C,
    startAgentTimeout: R,
    clearAgentTimeout: y,
    clearAgentTimeoutFailureReason: N,
    updateAgentTimeoutState: x,
    updateAgentTimeoutParticipantExists: j
  } = Tn(), z = r.useMemo(
    () => ({
      emitter: g,
      tokenSource: e,
      agentConnectTimeoutMilliseconds: o,
      agentTimeoutFailureReason: C,
      startAgentTimeout: R,
      clearAgentTimeout: y,
      clearAgentTimeoutFailureReason: N,
      updateAgentTimeoutState: x,
      updateAgentTimeoutParticipantExists: j
    }),
    [
      g,
      o,
      e,
      C,
      R,
      y,
      N,
      x,
      j
    ]
  ), B = r.useMemo(() => {
    const E = {
      room: c,
      internal: z
    };
    switch (M) {
      case I.Connecting:
        return {
          ...E,
          connectionState: I.Connecting,
          ...k(I.Connecting),
          local: {
            cameraTrack: void 0,
            microphoneTrack: void 0,
            screenShareTrack: void 0
          }
        };
      case I.Connected:
      case I.Reconnecting:
      case I.SignalReconnecting:
        return {
          ...E,
          connectionState: M,
          ...k(M),
          local: {
            cameraTrack: L,
            microphoneTrack: f,
            screenShareTrack: v
          }
        };
      case I.Disconnected:
        return {
          ...E,
          connectionState: I.Disconnected,
          ...k(I.Disconnected),
          local: {
            cameraTrack: void 0,
            microphoneTrack: void 0,
            screenShareTrack: void 0
          }
        };
    }
  }, [
    z,
    c,
    M,
    L,
    f,
    k
  ]);
  r.useEffect(() => {
    g.emit("connectionStateChanged", B.connectionState);
  }, [g, B.connectionState]);
  const K = Ln(
    g,
    B.connectionState
  ), Q = r.useCallback(
    async (E) => K(
      I.Connected,
      E
    ),
    [K]
  ), Y = r.useCallback(
    async (E) => K(I.Disconnected, E),
    [K]
  ), ne = r.useCallback(
    async (E) => c.setE2EEEnabled(E),
    [c]
  ), re = je(
    r.useMemo(
      () => ({
        connectionState: B.connectionState,
        room: c,
        internal: z
      }),
      [B, c, z]
    )
  ), S = An(e, a), _ = r.useRef(!1), Z = r.useCallback(
    async (E = {}) => {
      const {
        signal: D,
        tracks: W = { microphone: { enabled: !0, publishOptions: { preConnectBuffer: !0 } } },
        roomConnectOptions: fe
      } = E;
      await Y(D), _.current = !1;
      const ee = () => {
        c.disconnect();
      };
      D?.addEventListener("abort", ee);
      const ae = () => {
        _.current || S(!0);
      };
      c.once(H.Disconnected, ae);
      let Ee = !1;
      await Promise.all([
        S().then(({ serverUrl: Be, participantToken: Te }) => (Ee = (Wt(Te).roomConfig?.agents?.length ?? 0) > 0, c.connect(Be, Te, fe))),
        // Start microphone (with preconnect buffer) by default
        W.microphone?.enabled ? c.localParticipant.setMicrophoneEnabled(
          !0,
          void 0,
          W.microphone?.publishOptions ?? {}
        ) : Promise.resolve(),
        W.camera?.enabled ? c.localParticipant.setCameraEnabled(
          !0,
          void 0,
          W.camera?.publishOptions ?? {}
        ) : Promise.resolve(),
        W.screenShare?.enabled ? c.localParticipant.setScreenShareEnabled(
          !0,
          void 0,
          W.screenShare?.publishOptions ?? {}
        ) : Promise.resolve()
      ]), await Q(D), Ee && await re.waitUntilConnected(D), D?.removeEventListener("abort", ee);
    },
    [c, Y, S, Q, re.waitUntilConnected]
  ), $ = r.useCallback(async () => {
    _.current = !0, S(!0), await c.disconnect();
  }, [c, S]), q = r.useCallback(async () => {
    const E = await S();
    await c.prepareConnection(E.serverUrl, E.participantToken);
  }, [S, c]);
  return r.useEffect(
    () => {
      q().catch((E) => {
        console.warn("WARNING: Room.prepareConnection failed:", E);
      });
    },
    [
      /* note: no prepareConnection here, this effect should only ever run once! */
    ]
  ), r.useMemo(
    () => ({
      ...B,
      waitUntilConnected: Q,
      waitUntilDisconnected: Y,
      prepareConnection: q,
      start: Z,
      end: $,
      setEncryptionEnabled: ne
    }),
    [
      B,
      Q,
      Y,
      q,
      Z,
      $,
      ne
    ]
  );
}
function Cr(e, n, t, o) {
  const s = r.useMemo(() => () => {
  }, []), a = r.useCallback(t ?? s, o ?? []), i = o ? a : t, u = r.useMemo(() => e ? "internal" in e ? e.internal.emitter : e : null, [e]);
  r.useEffect(() => {
    if (!(!u || !i))
      return u.on(n, i), () => {
        u.off(n, i);
      };
  }, [u, n, i]);
}
var On = /* @__PURE__ */ ((e) => (e.MessageReceived = "messageReceived", e))(On || {});
function kr(e) {
  const { room: n } = ze(e), t = r.useMemo(
    () => new ke.EventEmitter(),
    []
  ), o = je(e), s = Sn({ room: n }), a = r.useMemo(() => ({ room: n }), [n]), i = un(a), u = r.useMemo(() => s.map((c) => {
    switch (c.participantInfo.identity) {
      case n.localParticipant.identity:
        return {
          type: "userTranscript",
          message: c.text,
          id: c.streamInfo.id,
          timestamp: c.streamInfo.timestamp,
          from: n.localParticipant
        };
      case o.internal.agentParticipant?.identity:
      case o.internal.workerParticipant?.identity:
        return {
          type: "agentTranscript",
          message: c.text,
          id: c.streamInfo.id,
          timestamp: c.streamInfo.timestamp,
          from: o.internal.agentParticipant?.identity === c.participantInfo.identity ? o.internal.agentParticipant : o.internal.workerParticipant
        };
      default:
        return {
          type: "agentTranscript",
          message: c.text,
          id: c.streamInfo.id,
          timestamp: c.streamInfo.timestamp,
          from: Array.from(n.remoteParticipants.values()).find(
            (g) => g.identity === c.participantInfo.identity
          )
        };
    }
  }), [s, n]), l = r.useMemo(() => [...u, ...i.chatMessages], [u, i.chatMessages]), h = r.useRef(/* @__PURE__ */ new Map()), m = r.useMemo(() => {
    const c = /* @__PURE__ */ new Date();
    for (const g of l)
      h.current.has(g.id) || h.current.set(g.id, c);
    return l.sort((g, k) => {
      const M = h.current.get(g.id), T = h.current.get(k.id);
      return typeof M > "u" || typeof T > "u" ? 0 : M.getTime() - T.getTime();
    });
  }, [l]), d = r.useRef(/* @__PURE__ */ new Set());
  return r.useEffect(() => {
    for (const c of m)
      d.current.has(c.id) || (d.current.add(c.id), t.emit("messageReceived", c));
  }, [m]), r.useMemo(
    () => ({
      messages: m,
      send: i.send,
      isSending: i.isSending,
      internal: { emitter: t }
    }),
    [m, i.send, i.isSending]
  );
}
function Er(e, n, t, o) {
  let s, a, i, u;
  Pn(e) ? (s = e, a = n, i = t, u = o) : (a = e, i = n, u = t);
  const { room: l } = ze(s), h = r.useRef(i);
  h.current = i;
  const m = r.useRef(u);
  m.current = u, r.useEffect(() => {
    if (a)
      return l.registerRpcMethod(a, async (c) => {
        const g = m.current?.fromIdentity;
        if (g && c.callerIdentity !== g)
          throw te.builtIn(
            "UNSUPPORTED_METHOD",
            `Method not available for caller ${c.callerIdentity}`
          );
        const k = h.current;
        if (!k)
          throw te.builtIn(
            "APPLICATION_ERROR",
            `No handler registered for method "${a}"`
          );
        const M = m.current?.serializer ?? we.json();
        let T;
        try {
          T = M.parse(c.payload);
        } catch (O) {
          throw te.builtIn("APPLICATION_ERROR", `Failed to parse RPC payload: ${O}`);
        }
        const w = await k(T, c);
        try {
          return M.serialize(w);
        } catch (O) {
          throw te.builtIn("APPLICATION_ERROR", `Failed to serialize RPC response: ${O}`);
        }
      }), () => {
        l.unregisterRpcMethod(a);
      };
  }, [l, a]);
  const d = r.useCallback(
    async (c, g = we.json()) => {
      if (Gt(g)) {
        let k;
        try {
          k = g.serialize(c.payload);
        } catch (T) {
          throw te.builtIn("APPLICATION_ERROR", `Failed to serialize RPC payload: ${T}`);
        }
        const M = await l.localParticipant.performRpc({
          destinationIdentity: c.destinationIdentity,
          method: c.method,
          payload: k,
          responseTimeout: c.responseTimeout
        });
        try {
          return g.parse(M);
        } catch (T) {
          throw te.builtIn("APPLICATION_ERROR", `Failed to parse RPC response: ${T}`);
        }
      } else
        return l.localParticipant.performRpc(c);
    },
    [l]
  );
  return r.useMemo(() => ({ perform: d }), [d]);
}
export {
  kr as $,
  $n as A,
  Xn as B,
  Ve as C,
  En as D,
  Pn as E,
  je as F,
  zn as G,
  hr as H,
  jn as I,
  Cr as J,
  Zt as K,
  Pe as L,
  On as M,
  vr as N,
  en as O,
  br as P,
  vn as Q,
  nn as R,
  wn as S,
  Qn as T,
  le as U,
  rn as V,
  Zn as W,
  Ce as X,
  Er as Y,
  yr as Z,
  Sr as _,
  oe as a,
  tr as a0,
  sn as a1,
  yn as a2,
  ar as a3,
  lr as a4,
  gn as a5,
  pr as a6,
  Sn as a7,
  gr as a8,
  or as b,
  Bn as c,
  qn as d,
  Gn as e,
  nr as f,
  rr as g,
  cr as h,
  Vn as i,
  A as j,
  ir as k,
  Yn as l,
  fr as m,
  Wn as n,
  Kn as o,
  sr as p,
  Xt as q,
  tn as r,
  mr as s,
  ur as t,
  Hn as u,
  er as v,
  un as w,
  dr as x,
  Jn as y,
  Un as z
};
//# sourceMappingURL=hooks-C7fu1g_i.mjs.map
